const isUserAgentSafe = () =>
  !/Ahrefs|Googlebot|bingbot|Slurp|Yandex|DuckDuckBot|S[eE][mM]rushBot|NetpeakSpiderBot/.test(
    window.navigator.userAgent
  );

export default isUserAgentSafe;
